import { cn } from '@/utils/utils';
import { ButtonCus } from '../common/Button';

interface ModalFooterProps {
    footerClassName?: string,
    cancelButton?: React.ReactNode,
    cancelButtonClassName?: string,
    onCancel?: Function,
    saveButton?: React.ReactNode,
    saveButtonClassName?: string,
    onSave?: Function
}

export default function ModalFooter({
    cancelButton,
    cancelButtonClassName,
    onCancel,
    saveButton,
    saveButtonClassName,
    onSave
}: ModalFooterProps) {
    return (
        <>
            {
                cancelButton && (
                    <ButtonCus
                        variant='outline'
                        size='inModal'
                        className={cn(cancelButtonClassName)}
                        onClick={() => onCancel?.()}
                    >
                        {cancelButton}
                    </ButtonCus>
                )
            }
            {
                saveButton && (
                    <ButtonCus
                        variant='default'
                        size='inModal'
                        className={cn(saveButtonClassName)}
                        onClick={() => onSave?.()}
                    >
                        {saveButton}
                    </ButtonCus>
                )
            }
        </>
    );
}
